// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

/** @public */
export type TLUiIconType =
	| 'align-bottom'
	| 'align-center-horizontal'
	| 'align-center-vertical'
	| 'align-left'
	| 'align-right'
	| 'align-top'
	| 'alt'
	| 'arrow-arc'
	| 'arrow-cycle'
	| 'arrow-elbow'
	| 'arrow-left'
	| 'arrowhead-arrow'
	| 'arrowhead-bar'
	| 'arrowhead-diamond'
	| 'arrowhead-dot'
	| 'arrowhead-none'
	| 'arrowhead-square'
	| 'arrowhead-triangle-inverted'
	| 'arrowhead-triangle'
	| 'blob'
	| 'bold'
	| 'bookmark'
	| 'bring-forward'
	| 'bring-to-front'
	| 'broken'
	| 'bulletList'
	| 'check-circle'
	| 'check'
	| 'chevron-down'
	| 'chevron-left'
	| 'chevron-right'
	| 'chevron-up'
	| 'chevrons-ne'
	| 'chevrons-sw'
	| 'clipboard-copied'
	| 'clipboard-copy'
	| 'closed'
	| 'code'
	| 'color'
	| 'comment'
	| 'corners'
	| 'crop'
	| 'cross-2'
	| 'cross-circle'
	| 'dash-dashed'
	| 'dash-dotted'
	| 'dash-draw'
	| 'dash-solid'
	| 'disconnected'
	| 'discord'
	| 'distribute-horizontal'
	| 'distribute-vertical'
	| 'dot'
	| 'dots-horizontal'
	| 'dots-vertical'
	| 'download'
	| 'drag-handle-dots'
	| 'duplicate'
	| 'edit'
	| 'external-link'
	| 'fill-fill'
	| 'fill-lined-fill'
	| 'fill-none'
	| 'fill-pattern'
	| 'fill-semi'
	| 'fill-solid'
	| 'follow'
	| 'following'
	| 'font-draw'
	| 'font-mono'
	| 'font-sans'
	| 'font-serif'
	| 'geo-arrow-down'
	| 'geo-arrow-left'
	| 'geo-arrow-right'
	| 'geo-arrow-up'
	| 'geo-check-box'
	| 'geo-cloud'
	| 'geo-diamond'
	| 'geo-ellipse'
	| 'geo-heart'
	| 'geo-hexagon'
	| 'geo-octagon'
	| 'geo-oval'
	| 'geo-pentagon'
	| 'geo-rectangle'
	| 'geo-rhombus-2'
	| 'geo-rhombus'
	| 'geo-star'
	| 'geo-trapezoid'
	| 'geo-triangle'
	| 'geo-x-box'
	| 'github'
	| 'group'
	| 'heading'
	| 'help-circle'
	| 'highlight'
	| 'horizontal-align-end'
	| 'horizontal-align-middle'
	| 'horizontal-align-start'
	| 'info-circle'
	| 'italic'
	| 'leading'
	| 'link'
	| 'list'
	| 'lock'
	| 'manual'
	| 'menu'
	| 'minus'
	| 'mixed'
	| 'pack'
	| 'plus'
	| 'question-mark-circle'
	| 'question-mark'
	| 'redo'
	| 'reset-zoom'
	| 'rotate-ccw'
	| 'rotate-cw'
	| 'send-backward'
	| 'send-to-back'
	| 'share-1'
	| 'size-extra-large'
	| 'size-large'
	| 'size-medium'
	| 'size-small'
	| 'spline-cubic'
	| 'spline-line'
	| 'stack-horizontal'
	| 'stack-vertical'
	| 'status-offline'
	| 'stretch-horizontal'
	| 'stretch-vertical'
	| 'strike'
	| 'text-align-center'
	| 'text-align-left'
	| 'text-align-right'
	| 'toggle-off'
	| 'toggle-on'
	| 'tool-arrow'
	| 'tool-eraser'
	| 'tool-frame'
	| 'tool-hand'
	| 'tool-highlight'
	| 'tool-laser'
	| 'tool-line'
	| 'tool-media'
	| 'tool-note'
	| 'tool-pencil'
	| 'tool-pointer'
	| 'tool-screenshot'
	| 'tool-text'
	| 'trash'
	| 'twitter'
	| 'underline'
	| 'undo'
	| 'ungroup'
	| 'unlock'
	| 'vertical-align-end'
	| 'vertical-align-middle'
	| 'vertical-align-start'
	| 'warning-triangle'
	| 'zoom-in'
	| 'zoom-out'

/** @public */
export const iconTypes = [
	'align-bottom',
	'align-center-horizontal',
	'align-center-vertical',
	'align-left',
	'align-right',
	'align-top',
	'alt',
	'arrow-arc',
	'arrow-cycle',
	'arrow-elbow',
	'arrow-left',
	'arrowhead-arrow',
	'arrowhead-bar',
	'arrowhead-diamond',
	'arrowhead-dot',
	'arrowhead-none',
	'arrowhead-square',
	'arrowhead-triangle-inverted',
	'arrowhead-triangle',
	'blob',
	'bold',
	'bookmark',
	'bring-forward',
	'bring-to-front',
	'broken',
	'bulletList',
	'check-circle',
	'check',
	'chevron-down',
	'chevron-left',
	'chevron-right',
	'chevron-up',
	'chevrons-ne',
	'chevrons-sw',
	'clipboard-copied',
	'clipboard-copy',
	'closed',
	'code',
	'color',
	'comment',
	'corners',
	'crop',
	'cross-2',
	'cross-circle',
	'dash-dashed',
	'dash-dotted',
	'dash-draw',
	'dash-solid',
	'disconnected',
	'discord',
	'distribute-horizontal',
	'distribute-vertical',
	'dot',
	'dots-horizontal',
	'dots-vertical',
	'download',
	'drag-handle-dots',
	'duplicate',
	'edit',
	'external-link',
	'fill-fill',
	'fill-lined-fill',
	'fill-none',
	'fill-pattern',
	'fill-semi',
	'fill-solid',
	'follow',
	'following',
	'font-draw',
	'font-mono',
	'font-sans',
	'font-serif',
	'geo-arrow-down',
	'geo-arrow-left',
	'geo-arrow-right',
	'geo-arrow-up',
	'geo-check-box',
	'geo-cloud',
	'geo-diamond',
	'geo-ellipse',
	'geo-heart',
	'geo-hexagon',
	'geo-octagon',
	'geo-oval',
	'geo-pentagon',
	'geo-rectangle',
	'geo-rhombus-2',
	'geo-rhombus',
	'geo-star',
	'geo-trapezoid',
	'geo-triangle',
	'geo-x-box',
	'github',
	'group',
	'heading',
	'help-circle',
	'highlight',
	'horizontal-align-end',
	'horizontal-align-middle',
	'horizontal-align-start',
	'info-circle',
	'italic',
	'leading',
	'link',
	'list',
	'lock',
	'manual',
	'menu',
	'minus',
	'mixed',
	'pack',
	'plus',
	'question-mark-circle',
	'question-mark',
	'redo',
	'reset-zoom',
	'rotate-ccw',
	'rotate-cw',
	'send-backward',
	'send-to-back',
	'share-1',
	'size-extra-large',
	'size-large',
	'size-medium',
	'size-small',
	'spline-cubic',
	'spline-line',
	'stack-horizontal',
	'stack-vertical',
	'status-offline',
	'stretch-horizontal',
	'stretch-vertical',
	'strike',
	'text-align-center',
	'text-align-left',
	'text-align-right',
	'toggle-off',
	'toggle-on',
	'tool-arrow',
	'tool-eraser',
	'tool-frame',
	'tool-hand',
	'tool-highlight',
	'tool-laser',
	'tool-line',
	'tool-media',
	'tool-note',
	'tool-pencil',
	'tool-pointer',
	'tool-screenshot',
	'tool-text',
	'trash',
	'twitter',
	'underline',
	'undo',
	'ungroup',
	'unlock',
	'vertical-align-end',
	'vertical-align-middle',
	'vertical-align-start',
	'warning-triangle',
	'zoom-in',
	'zoom-out',
] as const
